export const essentialTimezones: { [key: string]: string } = {
  // US timezones

  'America/Los_Angeles': 'Pacific Time',
  'America/Phoenix': 'Arizona',
  'America/Denver': 'Mountain Time',
  'America/Chicago': 'Central Time',
  'America/New_York': 'Eastern Time',

  // European timezones
  'Europe/London': 'London',
  'Europe/Berlin': 'Berlin',
  'Europe/Madrid': 'Madrid',
  'Europe/Paris': 'Paris',
};
